import { Column } from '../../model/common/column';
import { SelectItem } from '@openng/optimus-ui/api';

const trueFalse: SelectItem[] = [
  {
    label: 'Choose',
    value: null,
  },
  {
    label: 'true',
    value: true,
  },
  {
    label: 'false',
    value: false,
  },
];

export function getMOCEventColumns(
  eventTypes: SelectItem[],
  eventCategories: SelectItem[]
): Column[] {
  return [
    {
      field: 'title',
      header: 'CRM.LABEL.TITLE',
      formatPattern: 'text',
      width: '18%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'eventType',
      header: 'CRM.LABEL.EVENT_TYPE',
      formatPattern: 'text',
      type: 'dropdown',
      width: '4%',
      sortable: true,
      filterable: true,
      options: eventTypes,
      matchMode: 'equals',
    },
    {
      field: 'eventStatus',
      header: 'CRM.LABEL.EVENT_STATUS_HEADER',
      formatPattern: 'text',
      width: '4%',
      sortable: false,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'eventCategories',
      header: 'CRM.LABEL.EVENT_CATEGORY',
      formatPattern: 'text',
      type: 'dropdown',
      width: '9%',
      sortable: true,
      filterable: true,
      options: eventCategories,
      matchMode: 'equals',
    },
    {
      field: 'aors',
      header: 'CRM.LABEL.AOR',
      mobileHeader: 'CRM.LABEL.AOR',
      formatPattern: 'text',
      type: 'input',
      width: '14%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'description',
      header: 'CRM.LABEL.DESCRIPTION',
      mobileHeader: 'CRM.LABEL.DESCRIPTION',
      formatPattern: 'text',
      width: '24%',
      filterable: true,
      sortable: true,
    },
    {
      field: 'document',
      header: 'CRM.LABEL.DOCUMENT',
      mobileHeader: 'CRM.LABEL.DOCUMENT',
      formatPattern: 'hyperlink-url',
      type: 'text',
      width: '2%',
      filterable: false,
      sortable: false,
    },
    {
      field: 'startDt',
      header: 'COMMON.LABEL.START_DATE',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '6%',
      dateFormat: 'MM/dd/yyyy HH:mm:ss',
      sortable: true,
      filterable: true,
    },
    {
      field: 'endDt',
      header: 'COMMON.LABEL.END_DATE',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '6%',
      dateFormat: 'MM/dd/yyyy HH:mm:ss',
      sortable: true,
      filterable: true,
    },
    {
      field: 'createdAt',
      header: 'COMMON.LABEL.CREATED_AT',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '5%',
      dateFormat: 'MM/dd/yyyy hh:mm:ss aaa',
      sortable: true,
      filterable: true,
    },
    {
      field: 'sapOutageNumber',
      header: 'CRM.LABEL.SAP_OUTAGE_NUMBER_HEADER',
      formatPattern: 'text',
      width: '3%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'acknowledged',
      header: 'CRM.LABEL.ACKNOWLEDGED_HEADER',
      mobileHeader: 'CRM.LABEL.ACKNOWLEDGED_HEADER',
      formatPattern: 'text',
      width: '2%',
      type: 'dropdown',
      filterable: true,
      sortable: true,
      options: trueFalse,
      matchMode: 'equals',
    },
  ];
}
